import _Symbol$for from "@babel/runtime-corejs3/core-js-stable/symbol/for";

var nop = _Symbol$for("nop");

export default nop;